/**
 * Utility function to scroll to top of page
 * Uses multiple methods to ensure reliable scrolling across all browsers
 */
export const scrollToTop = () => {
  // Immediate scroll attempts
  window.scrollTo(0, 0);
  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0;

  // Additional scroll with options
  const scrollImmediate = () => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "auto",
    });
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  };

  // Multiple attempts to ensure scroll works
  scrollImmediate();

  // Small delays to handle any loading or rendering delays
  setTimeout(scrollImmediate, 10);
  setTimeout(scrollImmediate, 50);
  setTimeout(scrollImmediate, 100);

  // Final smooth scroll attempt
  setTimeout(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, 150);
};

/**
 * Enhanced scroll to top with additional options
 */
export const scrollToTopEnhanced = (options = {}) => {
  const { smooth = false, delay = 0, retries = 3 } = options;

  const performScroll = () => {
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;

    if (smooth) {
      setTimeout(() => {
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: "smooth",
        });
      }, 50);
    }
  };

  if (delay > 0) {
    setTimeout(performScroll, delay);
  } else {
    performScroll();
  }

  // Multiple retries to ensure scroll works
  for (let i = 1; i <= retries; i++) {
    setTimeout(performScroll, i * 50);
  }
};

export default scrollToTop;
